
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/timeline/templates/drop_status"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='arrow'></div>\n<div class='sprite-global glyph-disabled'></div>\n<div class='label'></div>\n<div class='story-range'></div>\n";
},"useData":true});
    }).call(this);
  